<ng-template #contentHeaderTemplate></ng-template>

<app-table id="dashboard.patients.index" [functionList]="tableFunctionList"></app-table>
